/* This file is auto-generated by scripts/generate-image-manifest.mjs */
/* Do not edit by hand. */

export const IMAGE_VARIANTS: Record<string, readonly number[]> = {
  "/images/hero-bg": [640,960,1280,1600,1920],
  "/images/industries/aerzte": [320,480,640,800,1024],
  "/images/industries/ecommerce": [320,480,640,800,1024],
  "/images/industries/ferienwohnung": [320,480,640,800,1024],
  "/images/industries/hotel": [320,480,640,800,1024],
  "/images/industries/immobilien": [320,480,640,800,1024],
  "/images/industries/industrie": [320,480,640,800,1024],
  "/images/industries/steuerberater": [320,480,640,800,1024],
  "/images/industries/vereine": [320,480,640,800,1024],
  "/images/logo": [64,96,128,192,256,384,512],
  "/images/ratgeber/barrierefreiheit-bfsg": [320,480,640,800,1024],
  "/images/ratgeber/buchungssysteme": [320,480,640,800,1024],
  "/images/ratgeber/digitalisierung-beratung": [320,480,640,800,1024],
  "/images/ratgeber/geo-seo-vs-geo": [320,480,640,800,1024],
  "/images/ratgeber/geo-warum-unsichtbar-bei-ki": [320,480,640,800,1024],
  "/images/ratgeber/hosting-betrieb": [320,480,640,800,1024],
  "/images/ratgeber/karriereseiten": [320,480,640,800,1024],
  "/images/ratgeber/ki-agentensysteme": [320,480,640,800,1024],
  "/images/ratgeber/ki-kompetenz-eu-ai-act": [320,480,640,800,1024],
  "/images/ratgeber/karriereseite-benefits-bewerbung": [320,480,640,800,1024],
  "/images/ratgeber/onlineshop-checkliste": [320,480,640,800,1024],
  "/images/ratgeber/php2shell-sicherheitsluecke": [320,480,640,800,1024],
  "/images/ratgeber/kilanka-fachsoftware": [320,480,640,800,1024],
  "/images/ratgeber/local-seo": [320,480,640,800,1024],
  "/images/ratgeber/webseite-erstellen": [320,480,640,800,1024],
  "/images/ratgeber/widerufsbutton": [320,480,640,800,1024],
  "/images/references/arztpraxis-zittau-desktop": [480,768,1024,1366],
  "/images/references/ballettkinder-desktop": [480,768,1024,1366],
  "/images/references/ballettkinder-tickets-desktop": [480,768,1024,1366,1600,1920],
  "/images/references/mundwerk-logopaedie-desktop": [480,768,1024,1366,1600,1920],
  "/images/references/flywithtoni-desktop": [480,768,1024,1366,1600,1920],
  "/images/references/bodenstaendig-desktop": [480,768,1024,1366,1600,1920],
  "/images/references/eggert-alm-desktop": [480,768,1024,1366],
  "/images/references/forsthaus-im-harz-desktop": [480,768,1024,1366,1600,1920],
  "/images/references/gattermann-desktop": [480,768,1024,1366,1600,1920],
  "/images/references/harzhuus-desktop": [480,768,1024,1366,1600,1920],
  "/images/references/hennecke-desktop": [480,768,1024,1366],
  "/images/references/ib-hahn-desktop": [480,768,1024,1366,1600,1920],
  "/images/references/mtg-steuer-desktop": [480,768,1024,1366],
  "/images/references/pasapa-desktop": [480,768,1024,1366,1600,1920],
  "/images/references/pension-wernigerode-desktop": [480,768,1024,1366,1600,1920],
  "/images/references/schlafconcept-desktop": [480,768,1024,1366],
  "/images/references/solehotels-desktop": [480,768,1024,1366],
  "/images/references/tagesmutti-desktop": [480,768,1024,1366],
  "/images/references/tennisclub-desktop": [480,768,1024,1366],
  "/images/references/ush-umwelt-desktop": [480,768,1024,1366,1600,1920],
  "/images/references/vbsimmo-desktop": [480,768,1024,1366,1600,1920],
  "/images/references/yoga-adya-desktop": [480,768,1024,1366,1600,1920],
  "/images/services/beratung": [320,480,640,800,1024],
  "/images/services/booking": [320,480,640,800,1024],
  "/images/services/geo": [320,480,640,800,1024],
  "/images/services/hosting": [320,480,640,800,1024],
  "/images/services/karriereseiten": [320,480,640,800,1024],
  "/images/services/ki-beratung": [320,480,640,800,1024],
  "/images/services/ki-kompetenz-schulung": [320,480,640,800,1024],
  "/images/services/onlineshop": [320,480,640,800,1024],
  "/images/services/sea": [320,480,640,800,1024],
  "/images/services/seo": [320,480,640,800,1024],
  "/images/services/webdesign": [320,480,640,800,1024],
  "/images/services/webseitencheck": [320,480,640,800,1024],
  "/images/team/enrico": [128,192,256,320,384,480],
  "/images/team/jens": [128,192,256,320,384],
} as const;

